const $ = jQuery.noConflict();

class Slider {
    constructor( selector, args = {} ) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        }
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign( {}, this.getDefaultSlickSettings(), this.args );
    }

    init() {
        let settings = this.getSlickSettings();

        $( this.selector ).slick( settings );

        $( this.selector ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ){
            let direction = null;

            if (currentSlide === 0 && nextSlide === slick.$slides.length - 1) {
                // its going from the first slide to the last slide (backwards)
                direction = 'prev';
            } else if (nextSlide > currentSlide || (currentSlide === (slick.$slides.length - 1) && nextSlide === 0 )) {
                // its either going normally forwards or going from the last slide to the first
                direction = 'next';
            } else {
                direction = 'prev';
            }

            this.closest('.acf-block' ).classList.add( 'slick-slider--animating-' + direction );
        } ).on( 'afterChange', function(){
            this.closest('.acf-block' ).classList.remove( 'slick-slider--animating-prev', 'slick-slider--animating-next' );
        } )
    }
}

const SimpleSlider = new Slider(
    '.gallery-slider__slider',
    {
        // variableWidth: true,
        dots: true,
        appendDots: ".gallery-slider__nav-inner",
        appendArrows: ".gallery-slider__nav-inner",
    }
);

const TestimonialSlider = new Slider(
    '.testimonial-slider',
    {
        // variableWidth: true,
        dots: true,
        appendDots: ".testimonial-slider__nav-inner",
        appendArrows: ".testimonial-slider__nav-inner",
        slidesToShow: 1,
        centerMode: true,
        // variableWidth: false,
        slidesToScroll: 1,
         autoplay: true,
         autoplaySpeed: 8000,

        // centerMode: false,
        // slidesToShow: 1,

        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    
                },
                breakpoint: 1200,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    
                },
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    
                },
            },
        ]
    }
);
console.log('TestimonialSlider',TestimonialSlider)
const FluidSlider = new Slider(
    '.gallery-slider__slider-fluid', 
    {
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1290,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                    slidesToShow: 3
                },
            },
        ],
    }
);
export { SimpleSlider, TestimonialSlider, FluidSlider };
